import React from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Styles from "./CompanyDetails.module.css";

const DOC_LIST = [
  { label: "PAN Card", key: "panDocId" },
  { label: "TAN", key: "tanDocId" },
  { label: "GST", key: "gstDocId" },
  { label: "Membership Form", key: "membershipFormDocId" },
  { label: "Trading Lisence", key: "tradingLicenseDocId" },
  { label: "Undertaking", key: "undertakingDocId" },
  { label: "Proof of Payment", key: "proofOfPaymentDocId" },
];

const DocumentDetails = ({ company, handlePreviewGeneralTerms }) => {
  const mapping = company?.companyDocumentMapping || {};
  console.debug("mapping", mapping);

  return (
    <div className={Styles.docSection}>
      <div className={Styles.docCard}>
        <div className={Styles.docCardTitle}>General Documents</div>
        <div className={Styles.docGrid}>
          {DOC_LIST.map(({ label, key }) => {
            const docId = mapping[key];
            return (
              <div key={key} className={Styles.docTile}>
                <span className={Styles.docTileLabel}>{label}</span>
                {docId ? (
                  <button
                    className={Styles.docViewBtn}
                    onClick={() => handlePreviewGeneralTerms(docId)}
                  >
                    <RemoveRedEyeIcon style={{ fontSize: "13px" }} />
                    View
                  </button>
                ) : (
                  <span className={Styles.docTileEmpty}>—</span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DocumentDetails;
